import { useAuth } from './useAuth';

export function useGirisYapilacakUserList() {
  const { user } = useAuth();

  const raw = localStorage.getItem('girisUserList') || '[]';
  let safeUserList;
  try {
    const parsed = JSON.parse(raw);
    safeUserList = Array.isArray(parsed) ? parsed : [];
  } catch {
    console.error('girisUserList parse hatası');
    safeUserList = [];
  }

  const userList = safeUserList.filter((item) => item.kullaniciIdStr !== user.userId);
  const kulDegistir = safeUserList.length > 1;

  return { userList, kulDegistir };
}
